<template lang="pug">
    v-dialog(v-model="_value")
        v-toolbar(:color="colors.primary" dark)
            v-icon.mr-2 search
            h1.title Búsqueda de Clientes
            v-progress-circular.loader(
                indeterminate
                v-if="loading"
            )
        v-card.px-3.py-2
            v-text-field(
                v-if="state === 1"
                label="Cliente"
                outline
                ref="customerInput"
                v-model="search"
                @keyup.enter="handleEnter()"
                @keydown="handleKeydown($event)"
                :disabled="loading")
            alter-auto-complete(
                v-if="state === 2"
                :items="options"
                ref="customerAComplete"
                outline
                label="Cliente"
                v-model="customerIndex"
                @change="handleChange($event)"
                @keydown="handleKeydown($event)"
                @item:click="handleClick($event)"
                )
            div(v-if="errorMessage")
                v-icon.mr-2(:color="colors.danger") error
                span.red--text {{errorMessage}}
</template>

<script>
// -- Component Imports --
import AlterAutoComplete from '@/components/AlterAutoComplete/AlterAutoComplete'
// -- JS Data files import --
// -- JS Libraries Import --
import CustomerModel from '@/models/Sale/SlCustomer'
import axios from 'axios'
// -- Mixins imports --
// -- Vuex Imports --
// -- Other Imports --
export default {
    name: 'component-name',
    props: {
        // ------------------------- UI State ---------------------------------
        /**
         * @description
         */
        value: {
            type: Boolean,
            default: () => true,
        },
        slim: {
            type: Boolean,
            default: true,
        },
        // ------------------------- Component Data ---------------------------
    },
    data: function() {
        return {
            // ------------------------ UI State ------------------------------
            loading: false,
            errorMessage: '',
            state: 1,
            // ------------------------ Data storing --------------------------
            search: '',
            customerList: [],
            options: [],
            customerIndex: null,
        }
    },
    computed: {
        // -------------------- Editable props binding-------------------------
        /**
         * @description
         */
        _value: {
            get: function() {
                return this.value
            },
            set: function(val) {
                this.$emit('input', val)
            },
        },
        // -------------------- Alias settings --------------------------------
        // -------------------- Dynamic UI State ------------------------------
        // -------------------- Displayed data --------------------------------
        // -------------------- Methods data ----------------------------------
        // -------------------- Vuex mappings ---------------------------------
    },
    methods: {
        // -------------------- UI Modification -------------------------------
        // -------------------- Data fetching ---------------------------------
        async fetchCustomers(search) {
            if (this.slim) {
                try {
                    let route =
                        process.env.VUE_APP_API_ROUTE +
                        '/sl_customer_search_slim' +
                        `?search_string=${search}`
                    let response = await axios.get(route)
                    return response.data
                } catch (e) {
                    return e
                }
            } else {
                let response = await CustomerModel.include('branch_offices.g_commune').where('search', search)
                    .params({ get_all_results: true })
                    .get()
                return response
            }
        },
        // -------------------- Data handling and transformations -------------
        async handleEnter() {
            this.errorMessage = ''
            if (this.search.length >= 3) {
                this.loading = true
                let response = await this.fetchCustomers(this.search)
                if (response.response && response.response.status === 500) {
                    this.errorMessage = response.response.data.message
                } else if (response.data.length === 0) {
                    this.errorMessage = 'No se encontraron resultados'
                } else if (response.data.length === 1) {
                    this.$emit('customer:set', response.data[0])
                    this._value = false
                } else {
                    this.customerList = response.data
                    this.options = this.customerList.map((customer, idx) => {
                        let cust = {
                            id: idx,
                            text:
                                customer.rut +
                                ', ' +
                                customer.alias_name +
                                ', ' +
                                customer.business_name,
                        }
                        return cust
                    })
                    this.state = 2
                    this.loading = false
                    this.$nextTick(() => this.$refs.customerAComplete.focus())
                }
                this.loading = false
            } else {
                this.errorMessage =
                    'La búsqueda debe ser de 3 caractéres cómo mínimo'
            }
        },
        handleChange() {
            let customer = this.customerList[this.customerIndex.id]
            this.$emit('customer:set', customer)
            this._value = false
        },
        initialData() {
            return {
                // ------------------------ UI State ------------------------------
                loading: false,
                errorMessage: '',
                state: 1,
                // ------------------------ Data storing --------------------------
                search: '',
                customerList: [],
                options: [],
                customerIndex: null,
            }
        },
        resetData() {
            Object.assign(this.$data, this.initialData())
        },
        handleKeydown(e) {
            if (e.keyCode === 27) this._value = false
            if (e.keyCode === 112) {
                if (this.state === 1) return
                this.resetData()
            }
        },
        handleClick(idx) {
            let customer = this.customerList[idx]
            this.$emit('customer:set', customer)
            this._value = false
        },
        // -------------------- Validations and Error handling ----------------
        // -------------------- Other functions -------------------------------
        // -------------------- Vuex mappings ---------------------------------
    },
    watch: {
        value: {
            handler() {
                if (this.value) {
                    this.resetData()
                    this.$nextTick(() => this.$refs.customerInput.focus())
                }
            },
            immediate: true,
        },
    },
    components: { 'alter-auto-complete': AlterAutoComplete },
    // mixins: [],
    // filters: {},
    // ------------------------ Lifecycle Methods -----------------------------
    // ------------------------ End Lifecycle Methods -------------------------
}
</script>

<style lang="scss" scoped>
.loader {
    position: absolute;
    right: 30px;
}
</style>
